import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 1.33c-4.78 0-8.67 3.89-8.67 8.67 0 2.021.697 3.882 1.862 5.358A9.984 9.984 0 0 1 12 14.656c2.529 0 4.969.978 6.808 2.702A8.625 8.625 0 0 0 20.67 12c0-4.78-3.89-8.67-8.67-8.67zm0 2.51a3.75 3.75 0 0 1 3.745 3.745A3.75 3.75 0 0 1 12 13.33a3.75 3.75 0 0 1-3.746-3.745A3.75 3.75 0 0 1 12 5.839z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
